export default __webpack_public_path__ + "static/media/dimond.a0aa3e44.webm";